export default "__VITE_ASSET__qGnh1XQA__"